import React from 'react';
import PropTypes from 'prop-types';

import DropdownHelper from "../../helpers/dropdown";

const Dropdown =
    ({ labelName, value, onChange, dropdownItems, disabled, defaultValue, placeholder, isEmpty }) => {

        const dropDownSelection = <select {...{
            className: `dropdown-select`,
            defaultValue: defaultValue || placeholder,
            value,
            onChange,
            disabled
        }} >
            {DropdownHelper.addPlaceholder(defaultValue, value, placeholder, isEmpty) && <option>
                {placeholder}
            </option>}
            {!isEmpty && dropdownItems.map((item, index) => {
                const { code, name, value } = item;

                return <option key={`${index}_${code || value}`} value={code || value}>
                    {name}
                </option>;
            })}
        </select>;

        return <div className={`dropdown`}>
            {labelName && <label className="dropdown-label" >
                <text>{labelName}</text> &nbsp;
            </label>}
            <div className={`dropdown-select-menu`}>
                {dropDownSelection}
            </div>
        </div>;
    };

Dropdown.displayName = `Dropdown`;

Dropdown.propTypes = {
    labelName: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    dropdownItems: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string,
            value: PropTypes.string,
            name: PropTypes.string
        })
    ).isRequired,
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    isEmpty: PropTypes.bool
};

export default Dropdown;